import React from 'react'
import './Navbar.scss'

const Navbar = () => {
    return (
        <div className='navbar'>
            <h1>Explore Mars</h1>
        </div>
    )
}

export default Navbar
